import { render, staticRenderFns } from "./FormSubjects.vue?vue&type=template&id=a918df46&"
import script from "./FormSubjects.vue?vue&type=script&lang=js&"
export * from "./FormSubjects.vue?vue&type=script&lang=js&"
import style0 from "./FormSubjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports